import axios from "axios";
// import { Message, MessageBox } from "element-ui";

// create an axios instance
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
const service = axios.create({
  baseURL: "https://api.cimomicro.com", // api 的 base_url
  withCredentials: true,
  timeout: 50000, // request timeout
});
service.defaults.headers.post["Content-Type"] = "application/json;";
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    // Do something with request error
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  // response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  (response) => {
    const res = response.data;
    if (res.errorCode !== 0 && res.code !== 200) {
      // Message({
      //   message: res.errorMsg || res.reason,
      //   type: "error",
      //   duration: 2000,
      // });
      return Promise.reject("error");
    } else {
      return res;
    }
  },
  (error) => {
    console.log("err" + error); // for debug
    // Message({
    //   message: error.message,
    //   type: "error",
    //   duration: 2000,
    // });
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js